import { Icon } from '@chakra-ui/react';

export default function SFXMarkFilled(props) {
  return (
    <Icon
      width={4}
      height='17px'
      viewBox='0 0 16 17'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M8 16.3281C3.64844 16.3281 0.03125 12.7109 0.03125 8.35938C0.03125 4 3.64062 0.390625 7.99219 0.390625C12.3516 0.390625 15.9688 4 15.9688 8.35938C15.9688 12.7109 12.3594 16.3281 8 16.3281ZM5.375 11.6406C5.55469 11.6406 5.71875 11.5781 5.84375 11.4531L8 9.28125L10.1641 11.4531C10.2812 11.5781 10.4453 11.6406 10.625 11.6406C10.9922 11.6406 11.2812 11.3516 11.2812 10.9922C11.2812 10.8125 11.2188 10.6484 11.0859 10.5312L8.92188 8.36719L11.0938 6.19531C11.2344 6.05469 11.2891 5.91406 11.2891 5.73438C11.2891 5.375 11 5.09375 10.6406 5.09375C10.4688 5.09375 10.3281 5.14844 10.1953 5.28125L8 7.46094L5.82031 5.28906C5.69531 5.17188 5.55469 5.10938 5.375 5.10938C5.01562 5.10938 4.73438 5.38281 4.73438 5.75C4.73438 5.92188 4.79688 6.07812 4.92188 6.20312L7.08594 8.36719L4.92188 10.5391C4.79688 10.6562 4.73438 10.8203 4.73438 10.9922C4.73438 11.3516 5.01562 11.6406 5.375 11.6406Z' />
    </Icon>
  );
}
